import styles from './Profile.module.css';

import { getImageURL } from '../../utils';

import React from "react";

function Profile() {
    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <h1 className={styles.title}>Hi, I'm Hoang</h1>
                <p className={styles.bio}>Bio Bio Bio Bio Bio Bio Bio Bio Bio Bio</p>
            </div>
            {/*<img src={getImageURL('profile.jpg')} alt="Profile Image" className={styles.profileImg} />*/}
            <img src={"/logo512.png"} alt="Profile Image" className={styles.profileImg} />
            <div className={styles.topBlur} />
            <div className={styles.bottomBlur} />
        </section>
    )
}

export default Profile;